<!-- Cabecera de botones -->
<div [ngClass]="{'card mb-2 wow detalle-cliente': true, disabledContent: !enableContent}">
  <form autocomplete="off" [formGroup]="formHeader">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: start;
        align-items: center;
      ">
        <div class="col">
          <h4>
            Datos del cliente
          </h4>
        </div>
        <div *ngIf="mode === 'EDIT' ||  mode === 'SHOW'" class="col" style="text-align: end;">
          <div class="d-flex align-items-center justify-content-end">
            <h4 class="mb-0 mr-3">Nota de Venta: {{nvFolio}}</h4>
            <!-- Badge con contador de facturas asociadas -->
            <div *ngIf="facturasAsociadas && facturasAsociadas.length > 0" class="position-relative facturas-badge-container">
              <button 
                type="button" 
                class="btn btn-info btn-sm" 
                (click)="toggleFacturasPopover()"
                mdbWavesEffect>
                <mdb-icon fas icon="file-invoice"></mdb-icon>
                Facturas ({{facturasAsociadas.length}})
              </button>
              <!-- Popover personalizado -->
              <div *ngIf="mostrarFacturasPopover" class="facturas-popover">
                <div class="facturas-popover-header">
                  <strong>Facturas Asociadas</strong>
                  <button type="button" class="close-btn" (click)="cerrarFacturasPopover()" aria-label="Cerrar">
                    <mdb-icon fas icon="times"></mdb-icon>
                  </button>
                </div>
                <div class="facturas-popover-body">
                  <ul class="list-unstyled mb-0">
                    <li *ngFor="let factura of facturasAsociadas" class="factura-item">
                      <strong>{{factura}}</strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filtros-body">
        <div class="row">
          <!-- Datos del cliente -->
          <div class="col">
            <!-- <div class="row">
            <div class="col" style="max-width: 200px;">
              <div class="md-form">
                <input
                  value=""
                  type="text"
                  id="nroDoc"
                  class="form-control"
                  placeholder="000"
                  required
                  #nroDoc
                />
                <label for="nroDoc">Nro. Doc.</label>
              </div>
            </div>
            <div class="col">
              <strong class="title">Factura asociada</strong>
              <span class="value">#999999</span>
            </div>
          </div> -->
            <div class="row mb-1">
              <div *ngIf="permiteUnidadNegocio" class="col" style="max-width: 300px;">
                <div class="md-form m-0">
                  <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                    placeholder="Unidad de negocio" [filterEnabled]="true" formControlName="unidad_negocio_codigo">
                  </mdb-select>
                  <div *ngIf="
                                    formHeader.get('unidad_negocio_codigo').invalid &&
                                    (formHeader.get('unidad_negocio_codigo').dirty ||
                                    formHeader.get('unidad_negocio_codigo').touched)
                                  ">
                    <mdb-error *ngIf="formHeader.get('unidad_negocio_codigo').hasError('required')">Ingrese unidad
                      de negocio
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form m-0">
                  <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha Doc.'" required
                    formControlName="fechaDoc" [disabled]="mode == 'EDIT'  || mode == 'SHOW'">
                  </mdb-date-picker>
                  <div *ngIf="
                        formHeader.get('fechaDoc').invalid &&
                        (formHeader.get('fechaDoc').dirty ||
                        formHeader.get('fechaDoc').touched)
                      ">
                    <mdb-error *ngIf="formHeader.get('fechaDoc').hasError('required')">
                      Ingrese fecha documento
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col" style="max-width: 200px;">
                <div class="md-form m-0">
                  <mdb-date-picker #datePickerFechaVencimiento [inline]="true" name="fechaVenc"
                    [placeholder]="'Fecha Venc.'" required formControlName="fechaVenc" [disabled]="true">
                  </mdb-date-picker>
                  <div *ngIf="
                        formHeader.get('fechaVenc').invalid &&
                        (formHeader.get('fechaVenc').dirty ||
                        formHeader.get('fechaVenc').touched)
                      ">
                    <mdb-error *ngIf="formHeader.get('fechaVenc').hasError('required')">
                      Ingrese fecha vencimiento
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>


            <!-- <div class="row">
            <div class="col" style="max-width: 200px;">
              <div class="md-form">
                <input
                  value=""
                  type="text"
                  id="rutCliente"
                  class="form-control"
                  placeholder="9.999.999-9"
                  required
                  #rutCliente
                />
                <label for="rutCliente">RUT del cliente</label>
              </div>
            </div>
          </div> -->
            <div class="row align-items-center">
              <div class="col" style="max-width: 200px;">
                <div class="md-form">
                  <input value="" type="text" id="rutprovedor" class="form-control" placeholder="9.999.999-9" required
                    [readonly]="mode === 'EDIT' || mode === 'SHOW' || formHeader.disabled" #rutprovedor formControlName="rutCliente"
                    formatRut />
                  <label for="rutprovedor">Rut de Cliente</label>
                  <div *ngIf="
                        formHeader.get('rutCliente').invalid &&
                        (formHeader.get('rutCliente').dirty ||
                        formHeader.get('rutCliente').touched)
                      ">
                    <mdb-error *ngIf="formHeader.get('rutCliente').hasError('required')">Ingrese cliente
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col d-flex" style="max-width: 300px;">
                <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                  (click)="abrirModalSeleccionarCliente()" [disabled]="mode == 'EDIT' || mode == 'SHOW' || formHeader.get('rutCliente').disabled">
                  <mdb-icon fas icon="search"></mdb-icon>
                </button>
                <h6 class="text-info" style="display: contents;" *ngIf="cliente?.nombre; else mjsConsultaRut">
                  {{ cliente.razon_social }}
                </h6>
                <ng-template #mjsConsultaRut>
                  <h6 class="text-info" style="display: contents;">Ingrese el RUT del cliente</h6>
                </ng-template>
              </div>
              <div class="col" style="max-width: 250px;">
                <div class="md-form">
                  <mdb-select label="Sucursal" [options]="optionsSucursal" placeholder="Seleccionar Sucursal"
                    [filterEnabled]="true" formControlName="sucursal"
                    [disabled]="mode == 'SHOW' || mode == 'EDIT'"></mdb-select>
                  <div *ngIf="
                                        formHeader.get('sucursal').invalid &&
                                        (formHeader.get('sucursal').dirty ||
                                        formHeader.get('sucursal').touched)
                                      ">
                    <mdb-error *ngIf="formHeader.get('sucursal').hasError('required')">Ingrese sucursal
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col" style="max-width: 250px;">
                <div class="md-form m-0">
                  <mdb-select label="Bodega" [options]="optionsBodega" placeholder="Seleccionar Bodega"
                    [filterEnabled]="true" formControlName="bodega"
                    [disabled]="mode == 'EDIT'  || mode == 'SHOW'"></mdb-select>
                  <div *ngIf="
                                                  formHeader.get('bodega').invalid &&
                                                  (formHeader.get('bodega').dirty ||
                                                  formHeader.get('bodega').touched)
                                                ">
                    <mdb-error *ngIf="formHeader.get('bodega').hasError('required')">
                      Ingrese bodega
                    </mdb-error>
                  </div>
                </div>
              </div>
            </div>



            <div class="row mb-1">
              <div class="col dato" style="max-width: 300px;">
                <strong class="title">Dirección</strong>
                <span class="value" *ngIf="sucursal?.direccion_completa; else dummyTxt">{{ sucursal.direccion_completa
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
              <div class="col dato" style="max-width: 250px;">
                <strong class="title">Comuna</strong>
                <span class="value" *ngIf="sucursal?.direccion_completa; else dummyTxt">{{ sucursal.nombreComuna
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
              <div class="col dato" style="max-width: 250px;">
                <strong class="title">Provincia</strong>
                <span class="value" *ngIf="sucursal?.direccion_completa; else dummyTxt">{{ sucursal.nombreProvincia
                  }}</span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
            </div>

            <!-- <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select label="Sucursal" [options]="optionsSucursal" placeholder="Seleccionar Sucursal"
                  [filterEnabled]="true"></mdb-select>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="dire" class="form-control" placeholder="Dirección" required #dire />
                <label for="dire">Dirección</label>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="comuna" class="form-control" placeholder="Comuna" required #comuna />
                <label for="comuna">Comuna</label>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="provincia" class="form-control" placeholder="Provincia" required
                  #provincia />
                <label for="provincia">Provincia</label>
              </div>
            </div>
          </div> -->

            <div class="row">
              <!-- <div class="col" style="max-width: 150px;">
                <strong class="title">Cond. Pago</strong>
                <span class="value">
                  <mdb-badge pill="true" success="true">Contado</mdb-badge>
                </span>
              </div> -->
              <div class="col-4">
                <div class="md-form">
                  <mdb-select label="Cond. Pago" [options]="optionsCondicionPago" placeholder="Cond. Pago"
                    [filterEnabled]="true" formControlName="condicionPago"
                    [disabled]="mode == 'EDIT' || mode == 'SHOW'"></mdb-select>
                  <div *ngIf="
                          formHeader.get('condicionPago').invalid &&
                          (formHeader.get('condicionPago').dirty ||
                          formHeader.get('condicionPago').touched)
                        ">
                    <mdb-error *ngIf="formHeader.get('condicionPago').hasError('required')">Ingrese condición de pago
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="md-form">
                  <mdb-select label="Vendedor" [options]="optionsVendedor" placeholder="Seleccionar vendedor"
                    [filterEnabled]="true" formControlName="vendedor"
                    [disabled]="mode == 'EDIT' || mode == 'SHOW'"></mdb-select>
                  <div *ngIf="
                          formHeader.get('vendedor').invalid &&
                          (formHeader.get('vendedor').dirty ||
                          formHeader.get('vendedor').touched)
                        ">
                    <mdb-error *ngIf="formHeader.get('vendedor').hasError('required')">Ingrese vendedor
                    </mdb-error>
                  </div>
                </div>
              </div>
              <div class="col-2 dato">
                <strong class="title">Lista de precios</strong>
                <span class="value" *ngIf="cliente">
                  {{ cliente.lista_precio_codigo }}
                </span>
                <div *ngIf="
                          formHeader.get('listaPrecios').invalid &&
                          (formHeader.get('listaPrecios').dirty ||
                          formHeader.get('listaPrecios').touched)
                        ">
                  <mdb-error *ngIf="formHeader.get('listaPrecios').hasError('required')">Ingrese lista de precios
                  </mdb-error>
                </div>
              </div>
              <div class="col" style="max-width: 100px; display: flex; align-items: center;">
                <h5>
                  <strong>
                    Descuento
                  </strong>
                </h5>
              </div>

              <div class="col dato dcto-box">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">%</div>
                  </div>
                  <input mdbInput type="text" id="descuentoPorcent" class="form-control py-0" #descuentoPorcent
                    decimales formControlName="descuentoPorcentaje">
                  <div *ngIf="formHeader.get('descuentoPorcentaje').invalid &&
                                                    (formHeader.get('descuentoPorcentaje').dirty ||
                                                    formHeader.get('descuentoPorcentaje').touched)
                                                  ">
                    <mdb-error
                      *ngIf="formHeader.get('descuentoPorcentaje').hasError('max') && cliente && cliente.descuento_maximo">
                      Valor no puede ser mayor a {{cliente.descuento_maximo }}
                    </mdb-error>
                  </div>
                </div>
              </div>

              <div class="col dcto-box">
                <div class="">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input mdbInput type="text" id="descuentoPesos" class="form-control py-0" #descuentoPesos monto
                      formControlName="descuentoMonto">
                  </div>
                </div>
              </div>

              <div class="col-auto d-flex align-items-center">
                <button mdbBtn *ngIf="descuentoDirty"
                  type="button" class="btn btn-sm btn-outline-secondary"
                  mdbWavesEffect
                  (click)="aplicarDescuentoGlobal()">
                  <mdb-icon fas icon="check"></mdb-icon>
                  Aplicar
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-1">
                <button mdbBtn type="button" class="" color="secondary" mdbWavesEffect
                  (click)="abrirModalDocsReferencia(mode)"
                  [disabled]="mode == 'SHOW' ||formHeader.get('rutCliente').value == '' || formHeader.get('rutCliente').value == null">
                  <mdb-icon fas icon="file"></mdb-icon>
                  doc ref.
                </button>
              </div>
              <div class="col">
                <h6 class="text-info" *ngIf="CountListDocRef > 0" style="margin-top: 1%;">
                  {{CountListDocRef}} doc Seleccionado
                </h6>
              </div>
            </div>
          </div>
        </div>
        <!-- FIN/ FILA #2 -->

        <!-- <div class="row">
          <div class="col">
            {{ formHeader.value | json }}
          </div>
        </div> -->

      </div>
    </div>
  </form>
</div>

<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<app-modal-docs-referencia (onCountListDocRef)="getCountListDocRef($event)"></app-modal-docs-referencia>